/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
jQuery(document).ready(function($){
	$('span#size_click').click(function(){
        $('div#care_info').hide();
        $('div#size_info').slideDown('slow');
      	$(this).addClass('act_this');
      	$(this).siblings().removeClass('act_this');
    });
    $('span#care_click').click(function(){
        $('div#size_info').hide();
        $('div#care_info').slideToggle('slow');
      	$(this).addClass('act_this');
      	$(this).siblings().removeClass('act_this');
    });
  $('#close_size_info').click(function(){
  	$('div#size_info').slideUp('slow');
  });
});

jQuery(document).ready(function($){
  // Faq's Active Classes
  $('.faq_ques').on('click', function(e){
    e.preventDefault();
    if($(this).parent('.faq_list').hasClass('faq_active')){
      $(this).parent('.faq_list').removeClass('faq_active');
      $(this).siblings('.faq_answer').slideToggle('100','linear');
      return false;
    } else {
      $(this).parent('.faq_list').addClass('faq_active');
      $(this).siblings('.faq_answer').slideToggle('100','linear');
      $(this).parent('.faq_list').siblings('.faq_active').find('.faq_answer').slideToggle('100','linear');
      $(this).parents('.faq_list').siblings('.faq_active').removeClass('faq_active');
      return false;
    }
  });

  //Play Video
  $('.video_play_icon').on('click', function(e){
    e.preventDefault();
    $(this).parent('.video_overlay').siblings('iframe')[0].src += "&autoplay=1";
    $(this).parent('.video_overlay').addClass('video_active');
  });

  // =============== Banner Slide ===================
   if (window.innerWidth <= 767) {
    // Remove all slides that have the .desktop_banner class
    $('.home-carousel .bannerMobileSlider .desktop_banner').each(function () {
      $(this).closest('div').remove(); // Remove the entire slide div
      console.log('slide');
    });
     
  }
   $('.home-carousel .bannerMobileSlider').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: false,
        responsive: [
        {
            breakpoint: 999999,
            settings: "unslick"
         },
        {
        breakpoint:768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });

  
});

function checkLazySize(){
  lazySizes.autoSizer.checkElems();
}
setTimeout(checkLazySize, 1000);
setTimeout(checkLazySize, 2000);
setTimeout(checkLazySize, 4000);

ScrollReveal().reveal('.product-top', { afterReveal: checkLazySize });






